const Class = require('../../base/Class');
const CommonUtil = require('../../utils/CommonUtil');
const GeoJSONUtil = require('../../utils/geojson/GeoJSONUtil');
const g2 = require('../../g2');
/**
 * @constructor
 * @classdesc 地图要素构造器
 * @alias G.utils.FeatureBuilder
 * @augments G.base.Class
 * @param {Object} options 构造参数
 * @param {String} options.idField 唯一标识属性
 * @param {G.utils.GeometryBuilder} options.geometryBuilder
 * @param {G.utils.SymbolBuilder} options.symbolBuilder
 * @returns {Object} 实例化对象
 */
const FeatureBuilder = Class.extend({
    options: {},
    initialize(options) {
        Class.setOptions(this, options);
    },
    /**
     *
     */
    destroy() {},
    /**
     * 构造元素
     * @method
     * @memberOf G.utils.FeatureBuilder.prototype
     * @param data {Object}
     */
    buildElement(data) {
        let geometry = this.buildGeometry(data);
        let symbol = this.buildSymbol(data);
        let attributeSet = this.buildAttributeSet(data);
        let element = null;
        if (geometry){
            let id = data[this.options.idField];
            if(id === undefined || id ===null || id === '' ){
                id = CommonUtil.newUUID32();
            }
            element = new g2.sfs.Element({
                id: id,
                geometry: geometry,
                symbol: symbol
            });
            element.attributeSet = attributeSet;
        }
       
        return element;
    },
    /**
     * 将GFeature转换成feature
     */
    buildElementFromGFeature(gFeature) {
        let element = null;
        try{
            let properties = gFeature.properties;
            let geometry = null;
            let data = {};
            for (let i = 0; i < properties.length; i++) {
                if (properties[i]['$type'].indexOf('GeometryProperty') > -1)  {
                    geometry = properties[i].geometry;
                } else {
                    const key = gFeature.fields.fields[i].name;
                    data[key] = properties[i].value;
                }
            }
            element = new g2.sfs.Element({
                id: gFeature._id,
                geometry: geometry,
            });
            let attributeSet = this.buildAttributeSet(data || {});
            element.attributeSet = attributeSet;
        }catch (e) {
            console.warn(e)
        }
        return element;
    },
    /**
     * 通过geojson构造元素 Feature
     * @method
     * @memberOf G.utils.FeatureBuilder.prototype
     * @param feature {Object}
     */
    buildElementFromGeoJSON(feature) {
        let element = null;
        try{
            element = new g2.sfs.Element({
                id: feature.id,
                geometry: g2.sfs.GeometryFactory.createGeometryFromGeoJson(feature.geometry),
            });
            let attributeSet = this.buildAttributeSet(feature.properties || {});
            element.attributeSet = attributeSet;
        }catch (e) {
            console.warn(e)
        }
        return element;
    },
    /**
     * 通过esrijson/arcgisjson构造元素
     * @method
     * @memberOf G.utils.FeatureBuilder.prototype
     * @param data {Object}
     */
    buildElementFromEsriJSON(data) {
        let toGeoJSON = new GeoJSONUtil();
        data = toGeoJSON.fromArcgis(data);
        let element;
        try{
            element = this.buildElement(data);
        }
        catch (e) {
            console.warn(e)
        }
        return element;    
    },
    /**
     * 通过kml构造元素
     * @method
     * @memberOf G.utils.FeatureBuilder.prototype
     * @param data {Object}
     */
    buildElementFromKml(data) {
        let toGeoJSON = new GeoJSONUtil();
        data = toGeoJSON.fromKml(data);
        let element;
        try{
            element = this.buildElement(data);
        }
        catch (e) {
            console.warn(e)
        }
        return element;    
    },       
    /**
     * 构造要素
     * @method
     * @memberOf G.utils.FeatureBuilder.prototype
     * @param data {Object}
     */
    buildFeature(data, elementLike) {
        let fields = new g2.sfs.Fields();
        let values = [],geometry;
        try{
            geometry = this.buildGeometry(data);
        }
        catch (e) {
            console.warn(e);
        }
       
        let feature = new g2.sfs.Feature({
            objectId: data[this.options.idField] || CommonUtil.newUUID32(),
            fields: fields,
            values: values,
            geometry: geometry
        });
        feature.id = feature.objectId;
        if (elementLike) {
            let attributeSet = this.buildAttributeSet(data);
            feature.attributeSet = attributeSet;
        } else {
            for (let k in data) {
                let field = new g2.sfs.Field({
                    name: k
                });
                let value = new g2.sfs.Value();
                value.setValue(data[k]);
                fields.add(field);
                values.push(value);
            }
        }
        return feature;
    },
    /**
     * 通过geojson构造要素
     * @method
     * @memberOf G.utils.FeatureBuilder.prototype
     * @param data {Object}
     */
    buildFeatureFromGeoJSON(data, elementLike) {
        let feature = this.buildFeature(data, elementLike);
        return feature;
    },
    /**
     * 通过esrijson/arcgisjson构造要素
     * @method
     * @memberOf G.utils.FeatureBuilder.prototype
     * @param data {Object}
     */
    buildFeatureFromEsriJSON(data, elementLike) {
        let toGeoJSON = new GeoJSONUtil();
        data = toGeoJSON.fromArcgis(data);
        let feature = this.buildFeature(data, elementLike);
        return feature;
    },
    /**
     * 通过kml构造要素
     * @method
     * @memberOf G.utils.FeatureBuilder.prototype
     * @param data {Object}
     */
    buildFeatureFromKml(data, elementLike) {
        let toGeoJSON = new GeoJSONUtil();
        data = toGeoJSON.fromKml(data);        
        let feature = this.buildFeature(data, elementLike);
        return feature;
    },    
    /**
     * 
     * @ignore
     * 
     * @param {any} data 
     */
    buildGeometry(data) {
        let geometry = this.options.geometryBuilder.build(data);
        return geometry;
    },
    /**
     * 
     * @ignore
     * @param {any} data 
     */
    buildSymbol(data) {
        let symbol = this.options.symbolBuilder.build(data);
        return symbol;
    },

    /**
     * @ignore
     * @param data {Object}
     */
    buildAttributeSet(data) {
        let attributeSet = new g2.sfs.AttributeSet();
        for (let key in data) {
            let attribute = new g2.sfs.Attribute({
                name: key,
                value: data[key]
            });
            attributeSet.add(attribute);
        }
        return attributeSet;
    }
});

module.exports = FeatureBuilder;